/* eslint-disable max-len, @typescript-eslint/no-explicit-any */
const windowJQuery = (window as any).$;
const existingJQuery = windowJQuery && windowJQuery.fn?.extend;

const $ = existingJQuery ? windowJQuery : require('jquery/dist/jquery');

if (!existingJQuery) {
  (window as any).$ = (window as any).jQuery = $;
  require('imports-loader?{"type": "commonjs", "wrapper": "window", "additionalCode": "var define = false; var exports = false;"}!legacy/3rdparty/chosen.jquery');
  require('legacy/3rdparty/select2-v3.5.2.min');
  // requires jQuery to be loaded; set `this` to window for backwards compatibility
  require('jquery-ui/dist/jquery-ui.min');
  require('imports-loader?{"type": "commonjs", "wrapper": "window", "additionalCode": "var define = false; var exports = false;"}!legacy/jquery/jquery.form');
  require('imports-loader?{"type": "commonjs", "wrapper": "window", "additionalCode": "var define = false; var exports = false;"}!legacy/jquery/jquery.numeric');
  require('imports-loader?{"type": "commonjs", "wrapper": "window", "additionalCode": "var define = false; var exports = false;"}!legacy/jquery/jquery.placeholder');
  require('imports-loader?{"type": "commonjs", "wrapper": "window", "additionalCode": "var define = false; var exports = false;"}!legacy/jquery/jquery.tinysort');
  require('imports-loader?{"type": "commonjs", "wrapper": "window", "additionalCode": "var define = false; var exports = false;"}!legacy/jquery/jquery.typewatch');
  require('./jquery_ujs');
  require('legacy/3rdparty/jquery-textntags');
  require('imports-loader?{"type": "commonjs", "wrapper": "window", "additionalCode": "var define = false; var exports = false;"}!blueimp-file-upload/js/jquery.fileupload');
  require('../../mobile/components/gh_mobile_flyout');
  require('../../mobile/components/gh_mobile_tabs');
}

require('./contains_insensitive');

export default $;
